import Swiper from 'swiper';
import inView from 'in-view';

export default function gallery() {
  let swiperDelay = 6000;
  let autoHeight = true;
  let autoplay = {
    delay: swiperDelay,
  };

  /**
   * Single unit settings
   */
  if ($('.single-unit').length) {
    autoplay = false;
    autoHeight = false;
  }

  function getSlideDataIndex(swiper) {
    var activeIndex = swiper.activeIndex;
    var slidesLen = swiper.slides.length;
    if (swiper.params.loop) {
      switch (swiper.activeIndex) {
        case 0:
          activeIndex = slidesLen - 3;
          break;
        case slidesLen - 1:
          activeIndex = 0;
          break;
        default:
          --activeIndex;
      }
    }
    return activeIndex;
  }

  function animateProgress($bullet, width = 100, duration = swiperDelay) {
    if (!autoplay) {
      duration = 1;
    }

    if (width == 100) {
      $bullet.find('.swiper-pagination-bullet__progression').clearQueue().css('width', 0).animate(
        {
          width: '100%',
        },
        duration,
        'linear'
      );
    } else {
      $bullet
        .find('.swiper-pagination-bullet__progression')
        .clearQueue()
        .animate(
          {
            width: width + '%',
          },
          duration,
          'linear'
        );
    }
  }

  $('.wp-block-gallery').each(function () {
    const galleryId = 'gallery-' + Math.random().toString(36).substring(7);
    const $gallery = $(this);
    const $swiper = $gallery.find('.swiper-container');
    const $caption = $gallery.find('.swiper-caption');
    const $zoom = $gallery.find('.gallery__zoom');
    const $swiperFooter = $gallery.find('.swiper-footer');
    let doAnimateProgress = true;

    $gallery.attr('id', galleryId);

    //Désactiver animation automatique au clic de la navigation, l'animation se fait en css
    $gallery.find('.swiper-button-prev, .swiper-button-next').click(function () {
      $gallery.addClass('deactivate-progress');
      doAnimateProgress = false;
    });

    $gallery.find('.swiper-caption').html($gallery.find('figcaption').first().html());

    /**
     * Modal gallery
     */
    $('#modal-gallery').appendTo('body');

    $('#modal-gallery').on('show.bs.modal', function () {
      $('body').addClass('modal-open--gallery');
    });

    $('#modal-gallery').on('hidden.bs.modal', function () {
      $('body').removeClass('modal-open--gallery');
    });

    if ($swiper.find('.swiper-slide').length <= 1) {
      $swiperFooter.hide();
      return;
    }

    if ($gallery.closest('.wp-block-columns').length) {
      $gallery.closest('.wp-block-columns').addClass('wp-block-columns--with-gallery');
      $gallery.closest('.wp-block-column').addClass('wp-block-column--with-gallery');
    }

    const swiper = new Swiper($swiper, {
      init: false,
      loop: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      autoHeight: autoHeight,
      autoplay: autoplay,
      pagination: {
        el: $gallery.find('.swiper-pagination'),
      },
      navigation: {
        nextEl: $gallery.find('.swiper-button-next'),
        prevEl: $gallery.find('.swiper-button-prev'),
      },
      on: {
        touchStart: function (event) {
          $gallery.addClass('deactivate-progress');
        },
        paginationRender: function (swiper, paginationEl) {
          $gallery
            .find('.swiper-pagination-bullet')
            .append('<span class="swiper-pagination-bullet__progression"></span>');

          animateProgress($gallery.find('.swiper-pagination-bullet').first());
        },
        init: function () {
          $('.swiper-slide-active img').addClass('animate-zoom-out-delay');
        },
        slideChangeTransitionStart: function () {
          if (swiper === undefined) {
            return;
          }

          if (doAnimateProgress) {
            //Display progression
            const $bullets = $gallery.find('.swiper-pagination-bullet');
            const currentSlide = getSlideDataIndex(swiper);

            if (currentSlide == 0) {
              animateProgress($bullets, 0, 0);
              animateProgress($gallery.find('.swiper-pagination-bullet').first());
            } else {
              $bullets.each(function (index, value) {
                if (index == currentSlide) {
                  animateProgress($(this));
                }
              });
            }
          }

          //Change caption
          $caption.empty();
          $caption.html($gallery.find('.swiper-slide-active figcaption').html());

          //Adjust footer height based on caption
          $gallery.find('.swiper-footer').css('min-height', $gallery.find('.swiper-caption').height() + 'px');
        },
      },
    });

    /**
     * Click zoom button
     */
    $zoom.click(function () {
      $gallery.addClass('deactivate-progress');
      swiper.autoplay.stop();
    });

    /**
     * Resize footer
     */
    $(window).resize(function () {
      $gallery.find('.swiper-footer').css('min-height', $gallery.find('.swiper-caption').height() + 'px');
    });
    $(window).resize();

    /**
     * Start swiper when in view
     */
    inView('#' + galleryId).once('enter', function (el) {
      swiper.init();
    });
  });
}
